// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1DlsI","title":"BackImages_title__3p8HP","images":"BackImages_images__10YLn"};